import { relations } from "drizzle-orm";
import {
  boolean,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  unique,
  uuid,
} from "drizzle-orm/pg-core";
import { user } from "../better-auth/auth-schema";
import { business } from "./businesses";
import { usageMetricType } from "./enums";

// Usage metrics table
export const usageMetrics = pgTable(
  "usage_metrics",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    businessId: integer("business_id")
      .notNull()
      .references(() => business.id),
    metricType: usageMetricType("metric_type").notNull(),
    quantity: integer("quantity").notNull().default(1),
    timestamp: timestamp("timestamp").notNull().defaultNow(),
  },
  (t) => [unique().on(t.businessId, t.metricType, t.timestamp)]
);

export const subscriptionStatusEnum = pgEnum("subscription_status", [
  "incomplete",
  "incomplete_expired",
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
  "paused",
]);

export const subscription = pgTable(
  "subscription",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    userId: text("user_id")
      .notNull()
      .references(() => user.id),
    businessId: integer("business_id")
      .notNull()
      .references(() => business.id),

    imageGenLimit: integer("image_gen_limit").notNull(),
    articleGenLimit: integer("article_gen_limit").notNull(),

    billingPeriodStart: timestamp("billing_period_start").notNull(),
    billingPeriodEnd: timestamp("billing_period_end").notNull(),

    stripeCustomerId: text("stripe_customer_id"),
    stripeSubscriptionId: text("stripe_subscription_id"),

    cancelAt: timestamp("cancel_at"),

    status: subscriptionStatusEnum("status"),

    trialStart: timestamp("trial_start"),
    trialEnd: timestamp("trial_end"),

    cancelAtPeriodEnd: boolean("cancel_at_period_end"),
  },
  (t) => [unique().on(t.userId, t.businessId)]
);

export const subscriptionRelations = relations(subscription, (r) => ({
  user: r.one(user, {
    fields: [subscription.userId],
    references: [user.id],
  }),
  business: r.one(business, {
    fields: [subscription.businessId],
    references: [business.id],
  }),
}));
